import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'container-query-polyfill';
import "./services/AxiosInterceptors";
import { MonitoringContextProvider } from './contexts/MonitoringContextProvider';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(MonitoringContextProvider, { children: _jsx(App, {}) }));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
